import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { faUpload, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { OfflineService } from '@evorait/pace-offline';
import { ModalClass, ReportIssueComponent, ReportIssueModel } from '@evorait/pace-core';
import { HttpErrorResponse } from '@angular/common/http';
import { safeStringify } from '@evorait/pace-components';
import { BackendErrorDetails } from '../../services/config/backend-error-messages.config';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Component({
    selector: 'pace-core-backend-error-message-modal',
    templateUrl: './backend-error-message-modal.component.html',
    styleUrls: ['./backend-error-message-modal.component.scss'],
})
export class BackendErrorMessageModalComponent implements OnInit {
    @Input({ required: true })
    public errorData: {
        customErrorDetails: BackendErrorDetails;
        rawError: HttpErrorResponse;
    };

    public isDetailExpanded = false;
    public pendingRequestCount$: Observable<number>;

    public readonly faUpload = faUpload;
    public readonly faChevronUp = faChevronUp;
    public readonly faChevronDown = faChevronDown;

    public constructor(
        public readonly modalInstance: BsModalRef,
        private readonly modalService: BsModalService,
        private offlineService: OfflineService,
        private readonly translate: TranslateService,
    ) {}

    public ngOnInit(): void {
        this.pendingRequestCount$ = this.offlineService.pendingRequestCount$;

        this.normalizeErrorData();
    }

    private normalizeErrorData(): void {
        const rawError = this.errorData.rawError ?? {};
        const customError = this.errorData.customErrorDetails ?? {};
        this.errorData.customErrorDetails = {
            message: customError.message ?? this.translate.instant('ERROR_MESSAGE_MODAL_DEFAULT_MESSAGE'),
            action: customError.action ?? this.translate.instant('ERROR_MESSAGE_MODAL_DEFAULT_ACTION'),
        };

        this.errorData.rawError = new HttpErrorResponse({
            url: rawError.url ?? <string>this.translate.instant('ERROR_MESSAGE_MODAL_DEFAULT_URL'),
            error: rawError.error ?? '',
            status: rawError.status ?? 0,
            statusText:
                rawError.statusText ?? <string>this.translate.instant('ERROR_MESSAGE_MODAL_DEFAULT_STATUS_TEXT'),
        });
    }

    public reportAnIssue(): void {
        this.modalInstance.hide();
        this.modalService.show(ReportIssueComponent, {
            backdrop: 'static',
            class: ModalClass.MODAL_LARGE,
            initialState: {
                model: new ReportIssueModel(this.errorData.customErrorDetails.message),
            },
            ariaLabelledBy: 'report-issue-modal-title',
        });
    }

    public close(): void {
        this.modalInstance.hide();
    }

    public toggleDetailsExpansion(): void {
        this.isDetailExpanded = !this.isDetailExpanded;
    }

    public get formattedError(): string {
        const error = this.errorData.rawError.error;

        if (!error) {
            return '';
        } else if (typeof error === 'object') {
            return safeStringify(error);
        } else {
            return String(error);
        }
    }
}
